<template>
  <div>
    <!--面包屑导航区域-->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>设备管理</el-breadcrumb-item>
      <el-breadcrumb-item>淋浴付费配置</el-breadcrumb-item>
    </el-breadcrumb>
    <!--面包屑导航区域-->
    <!--卡片视图区-->
    <br>
    <el-card>
      <!--搜索与添加区域-->
      <el-row :gutter="20">
        <el-col :span="10">
          <el-select v-model="queryInfo.storeId" filterable placeholder="请选择门店">
            <el-option v-for="opt in storeAlllist" :key="opt.id" :label="opt.storename" :value="opt.id"/>
          </el-select>
        </el-col>
        <el-col :span="10">
          <el-select v-model="queryInfo.isActive" filterable placeholder="请选择状态">
            <el-option v-for="opt in activeArr" :key="opt.id" :label="opt.val" :value="opt.id"/>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" icon="el-icon-plus" @click="AddStoreBath()" v-permission="'btn:bath:add'">设置淋浴付费</el-button>
        </el-col>
      </el-row>
      <!--搜索与添加区域-->
      <br>
      <!--用户列表区域-->
      <el-table v-loading="loading" :data="list"  :key="list.index" style="width: 100%" stripe size="middle" height="780">
        <el-table-column label="序号" type="index"  width="100"></el-table-column>
        <el-table-column label="门店名称" prop="storename" show-overflow-tooltip></el-table-column>
        <el-table-column label="收费类型" prop="count" width="100">
          <template slot-scope="scope">
            <el-tag type="primary" v-if="scope.row.chargeType.indexOf('free') > -1">免费</el-tag>
            <el-tag type="success" v-else-if="scope.row.chargeType.indexOf('per_time') > -1">按次收费</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="是否激活" width="120" align="center">
          <template slot-scope="scope">
            <el-tooltip
                :content="scope.row.isActive == '1' ? '激活' : '失效'"
                placement="top"
            >
              <el-switch
                  v-model="scope.row.isActive"
                  :active-value="1"
                  :inactive-value="0"
                  active-color="#67c23a"
                  inactive-color="#c0c4cc"
                  @change="toggleStorePriceShow(scope.row)"
                  style="margin: 0;">
              </el-switch>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="生效时间">
          <template slot-scope="scope">
            <span v-if="scope.row.startTime">
              {{formatTime(scope.row.startTime)}} ~ {{formatTime(scope.row.endTime)}}
            </span>
            <span v-else>
              全时间段生效
            </span>
          </template>
        </el-table-column>
        <el-table-column label="备注" prop="remark" show-overflow-tooltip></el-table-column>
        <el-table-column label="操作" width="350">
          <!--作用域插槽-->
          <template slot-scope="scope">
            <div class="button-group">
              <el-tooltip content="编辑" placement="top" :enterable="false">
                <el-button type="success" icon="el-icon-edit" size="mini" circle @click="EditInfo(scope.row)" v-permission="'btn:bath:edit'"></el-button>
              </el-tooltip>
              <el-tooltip content="删除" placement="top" :enterable="false">
                <el-button type="danger" icon="el-icon-delete" size="mini" circle @click="DelInfo(scope.row.id)" v-permission="'btn:bath:delete'"></el-button>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!--用户列表区域-->
      <!--添加对话框-->
      <el-dialog title="添加门店淋浴配置" :visible.sync="addDialogVisible" width="60%" top="150px" @close="addDialogClosed">
        <div style="height: 500px;overflow-y: auto">
          <el-form :model="addForm" :rules="addFormRules" ref="addFormRef"  label-width="100px">
            <el-form-item label="门店" prop="storeId">
              <el-select v-model="addForm.storeId" filterable placeholder="请选择门店" style="width: 100%;" clearable>
                <el-option v-for="item in storelist" :key="item.id" :label="item.storename" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="收费类型" prop="chargeType">
              <el-checkbox-group v-model="addForm.chargeType" @change="handleChangeType">
<!--                <el-checkbox label="free">免费</el-checkbox>-->
                <el-checkbox label="per_time" disabled>按次收费</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="单次价格" prop="pricePerTime" v-if="addForm.chargeType.indexOf('per_time') > -1">
              <el-input v-model="addForm.pricePerTime" placeholder="请输入单次价格">
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
            <el-form-item label="单次时长" prop="maxDurationMinutes" v-if="addForm.chargeType.indexOf('per_time') > -1">
              <el-input v-model="addForm.maxDurationMinutes" placeholder="请输入单次时长">
                <template slot="append">分钟</template>
              </el-input>
            </el-form-item>
            <el-form-item label="备注" prop="remark">
              <el-input v-model="addForm.remark" maxlength="50" type="textarea" show-word-limit
                        placeholder="请输入备注"></el-input>
            </el-form-item>
<!--            <el-form-item label="免费时长" prop="freeMinutesDaily" v-if="addForm.chargeType === 'free'">-->
<!--              <el-input v-model="addForm.freeMinutesDaily" placeholder="请输入免费时长">-->
<!--                <template slot="append">分钟</template>-->
<!--              </el-input>-->
<!--            </el-form-item>-->
            <el-form-item label="开始时间" v-if="addForm.chargeType.indexOf('per_time') > -1">
              <el-time-picker
                  is-range
                  v-model="startTimeArr"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  placeholder="选择时间范围">
              </el-time-picker>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer" style="margin:0">
            <el-button @click="addDialogClosed">取消</el-button>
            <el-button @click="AddInfo" style="background:#19aa8d;color:#fff" v-loading="btnLoading">确 定</el-button>
        </span>
      </el-dialog>
      <!--添加对话框-->
      <!-- 编辑对话框 -->
      <el-dialog title="编辑门店淋浴配置" :visible.sync="editDialogVisible" width="500px" top="50px" @close="editDialogClosed">
        <div style="height: 500px;overflow-y: auto">
          <el-form :model="editForm" :rules="editFormRules" ref="editFormRef"  label-width="100px">
            <el-form-item label="门店">
              {{editForm.storename}}
            </el-form-item>
            <el-form-item label="收费类型" prop="chargeType">
              <el-checkbox-group v-model="editForm.chargeType" @change="handleChangeType">
                <!--                <el-checkbox label="free">免费</el-checkbox>-->
                <el-checkbox label="per_time" disabled>按次收费</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="单次价格" prop="pricePerTime" v-if="editForm.chargeType.indexOf('per_time') > -1">
              <el-input v-model="editForm.pricePerTime" placeholder="请输入单次价格">
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
            <el-form-item label="单次时长" prop="maxDurationMinutes" v-if="editForm.chargeType.indexOf('per_time') > -1">
              <el-input v-model="editForm.maxDurationMinutes" placeholder="请输入单次时长">
                <template slot="append">分钟</template>
              </el-input>
            </el-form-item>
            <el-form-item label="备注" prop="remark">
              <el-input v-model="editForm.remark" maxlength="50" type="textarea" show-word-limit
                        placeholder="请输入备注"></el-input>
            </el-form-item>
<!--            <el-form-item label="免费时长" prop="freeMinutesDaily" v-if="editForm.chargeType === 'free'">-->
<!--              <el-input v-model="editForm.freeMinutesDaily" placeholder="请输入免费时长">-->
<!--                <template slot="append">分钟</template>-->
<!--              </el-input>-->
<!--            </el-form-item>-->
            <el-form-item label="开始时间" v-if="editForm.chargeType.indexOf('per_time') > -1">
              <el-time-picker
                  is-range
                  v-model="startTimeArr"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  placeholder="选择时间范围">
              </el-time-picker>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer" style="margin:0">
            <el-button @click="editDialogClosed">取消</el-button>
            <el-button @click="EditInfoSave" style="background:#19aa8d;color:#fff" v-loading="btnLoading">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 编辑对话框 -->
    </el-card>
  </div>
</template>

<script>

export default {
  data() {
    return{
      btnLoading: false,
      queryInfo: {
        storeId: null,
        isActive: null
      },
      list: [],
      loading:false,
      addDialogVisible:false,
      editDialogVisible:false,
      storelist:[],
      storeAlllist:[],
      activeArr:[{
        id: 1,
        val: '激活'
      },{
        id: 0,
        val: '失效'
      }],
      // 开始时间
      startTimeArr: null,
      //添加表单数据
      addForm:{
        storeId:null,
        chargeType:['per_time'],
        pricePerTime:null,
        freeMinutesDaily:null,
        maxDurationMinutes:null,
        startTime:null,
        endTime:null,
        remark:null,
        isActive:1,
      },
      editForm:{
        storeId:null,
        chargeType:['per_time'],
        pricePerTime:null,
        freeMinutesDaily:null,
        maxDurationMinutes:null,
        startTime:null,
        endTime:null,
        remark:null,
        isActive:1,
      },
      addFormRules:{
        storeId:[
          { required: true, message: '请选择门店', trigger: 'blur' }
        ],
        chargeType:[
          { required: true, message: '请选择收费类型', trigger: 'blur' }
        ],
        pricePerTime:[
          { required: true, message: '单次价格不可为空', trigger: 'blur' },
          { pattern: /^(\d|([1-9]\d?))$/, message: '单次价格最大99元', trigger: 'blur' },
        ],
        maxDurationMinutes:[
          { required: true, message: '单次时长不可为空', trigger: 'blur' },
          { pattern: /^(\d|([1-9]\d?))$/, message: '单次时长最大99分钟', trigger: 'blur' },
        ],
        freeMinutesDaily:[]
      },
      editFormRules:{
        storeId:[
          { required: true, message: '请选择门店', trigger: 'blur' }
        ],
        chargeType:[
          { required: true, message: '请选择收费类型', trigger: 'blur' }
        ],
        pricePerTime:[
          { required: true, message: '单次价格不可为空', trigger: 'blur' },
          { pattern: /^(\d|([1-9]\d?))$/, message: '单次价格最大99元', trigger: 'blur' },
        ],
        maxDurationMinutes:[
          { required: true, message: '单次时长不可为空', trigger: 'blur' },
          { pattern: /^(\d|([1-9]\d?))$/, message: '单次时长最大99分钟', trigger: 'blur' },
        ],
        freeMinutesDaily:[]
      },
    }

  },
  created(){
    this.prefix = this.$http.defaults.baseURL
    this.getStoreList()
    this.getAllStoreList()
    this.getList()
  },
  methods:{
    formatTime(now) {
      if (typeof now === 'string') {
        now = new Date(now)
      }
      return now.getHours() < 10 ? '0' + now.getHours() : now.getHours() + ":" + (now.getMinutes() < 10 ? '0' + now.getMinutes() : now.getMinutes()) + ":" + (now.getSeconds() < 10 ? '0' + now.getSeconds() : now.getSeconds());
    },
    async getList() {
      this.loading = true
      const { data: res} = await this.$http.post('getBathConfigList',{ params: this.queryInfo })
      if(res.status == 1){
        this.list = res.data
        this.loading = false
      }
    },
    AddStoreBath(){
      this.addForm = {
        storeId:null,
        chargeType:['per_time'],
        pricePerTime:null,
        freeMinutesDaily:null,
        maxDurationMinutes:null,
        startTime:null,
        endTime:null,
        remark:null,
        isActive:1,
      }
      this.btnLoading = false
      this.addFormRules.pricePerTime = [
        { required: true, message: '单次价格不可为空', trigger: 'blur' },
        { pattern: /^(\d|([1-9]\d?))$/, message: '单次价格最大99元', trigger: 'blur' },
      ]
      this.addFormRules.maxDurationMinutes = [
        { required: true, message: '单次时长不可为空', trigger: 'blur' },
        { pattern: /^(\d|([1-9]\d?))$/, message: '单次时长最大99分钟', trigger: 'blur' },
      ]
      this.addFormRules.freeMinutesDaily = []
      this.startTimeArr = null
      this.addDialogVisible =  true
    },
    addDialogClosed(){
      this.$refs.addFormRef.resetFields()
      this.addDialogVisible =  false
    },
    editDialogClosed(){
      this.$refs.editFormRef.resetFields()
      this.editDialogVisible =  false
    },
    async getStoreList(){
      const { data: res } = await this.$http.get('bath/store')
      this.storelist = res.data
    },
    async getAllStoreList(){
      const { data: res } = await this.$http.get('store/')
      this.storeAlllist = res.data
    },
    AddInfo(){
      this.$refs.addFormRef.validate( async valid=>{
        if (!valid) return
        this.btnLoading = true
        let params = {...this.addForm}
        if (this.startTimeArr) {
          params.startTime = this.startTimeArr[0]
          params.endTime = this.startTimeArr[1]
        }
        params.chargeType = this.addForm.chargeType.join(',')

        const { data:res } = await this.$http.post('addBathConfig',params)
        if(res.status===0)
        {
          this.$message.success('添加成功！')
          this.addDialogVisible = false
          this.getList()
        }else{
          this.$message({message: res.msg,type: 'error'})
        }
        this.btnLoading = false
      })
    },
    async EditInfo(row){
      this.btnLoading = false
      let obj = {...row}
      obj.chargeType = row.chargeType.split(',')
      this.handleChangeType(obj.chargeType)
      if (obj.startTime) {
        this.startTimeArr = [new Date(obj.startTime), new Date(obj.endTime)]
      }
      this.editForm = obj
      this.editDialogVisible = true
    },
    EditInfoSave(){
      this.$refs.editFormRef.validate(async valid => {
        if (!valid) return
        this.btnLoading = true
        let params = {...this.editForm}
        if (this.startTimeArr) {
          params.startTime = this.startTimeArr[0]
          params.endTime = this.startTimeArr[1]
        }
        params.chargeType = this.editForm.chargeType.join(',')

        const { data: res } = await this.$http.post('editBathConfig/' + params.id,params)
        if (res.status === 0) {
          this.$message.success('信息修改成功')
          this.editDialogVisible = false
          this.getList()
          this.getStoreList()
        }
        this.btnLoading = false
      })
    },
    async DelInfo(id){
      const confirmResult = await this.$confirm('是否要删除此信息吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).catch(err => err)

      if (confirmResult !== 'confirm'){
        return this.$message.info('已取消删除！')
      }
      const { data: res } = await this.$http.get('delBathConfig/'+ id)

      if (res.status === 0) {
        this.$message({message: '删除成功！',type: 'success'})
      }
      this.getList()
      this.getStoreList()
    },
    // 切换店铺价格显示状态
    async toggleStorePriceShow(row) {
      // el-switch 组件在触发 change 事件时，已经更新了 v-model 的值
      // 所以 row.isActive 已经是新的状态值
      const newShowStatus = row.isActive
      const showText = newShowStatus === 1 ? '激活' : '失效'

      try {
        const { data: res } = await this.$http.post('bath/toggle-hide', {
          id: row.id,
          isActive: newShowStatus
        })

        if (res.status === 0) {
          this.$message.success(`设置为${showText}成功`)
        } else {
          this.$message.error(res.message || `设置为${showText}失败`)
          // 如果操作失败，需要恢复开关状态
          row.isActive = newShowStatus === 1 ? 0 : 1
        }
      } catch (error) {
        console.error(`设置为${showText}失败:`, error)
        this.$message.error(`设置为${showText}失败`)
        // 如果操作失败，需要恢复开关状态
        row.isActive = newShowStatus === 1 ? 0 : 1
      }
    },
    handleChangeType(val) {
      this.addForm.pricePerTime = null
      this.addForm.maxDurationMinutes = null
      this.addForm.freeMinutesDaily = null
      this.editForm.pricePerTime = null
      this.editForm.maxDurationMinutes = null
      this.editForm.freeMinutesDaily = null
      this.startTimeArr = null
      if (val.indexOf("free") > -1) {
        this.addFormRules.pricePerTime = []
        this.addFormRules.maxDurationMinutes = []
        this.addFormRules.freeMinutesDaily = [
          { required: true, message: '每日免费分钟不可为空', trigger: 'blur' },
          { pattern: /^(\d|([1-9]\d?))$/, message: '免费分钟最大99分钟', trigger: 'blur' },
        ]
        this.editFormRules.pricePerTime = []
        this.editFormRules.maxDurationMinutes = []
        this.editFormRules.freeMinutesDaily = [
          { required: true, message: '每日免费分钟不可为空', trigger: 'blur' },
          { pattern: /^(\d|([1-9]\d?))$/, message: '免费分钟最大99分钟', trigger: 'blur' },
        ]
      } else {
        this.addFormRules.pricePerTime = [
          { required: true, message: '单次价格不可为空', trigger: 'blur' },
          { pattern: /^(\d|([1-9]\d?))$/, message: '单次价格最大99元', trigger: 'blur' },
        ]
        this.addFormRules.maxDurationMinutes = [
          { required: true, message: '单次时长不可为空', trigger: 'blur' },
          { pattern: /^(\d|([1-9]\d?))$/, message: '单次时长最大99分钟', trigger: 'blur' },
        ]
        this.addFormRules.freeMinutesDaily = []
        this.editFormRules.pricePerTime = [
          { required: true, message: '单次价格不可为空', trigger: 'blur' },
          { pattern: /^(\d|([1-9]\d?))$/, message: '单次价格最大99元', trigger: 'blur' },
        ]
        this.editFormRules.maxDurationMinutes = [
          { required: true, message: '单次时长不可为空', trigger: 'blur' },
          { pattern: /^(\d|([1-9]\d?))$/, message: '单次时长最大99分钟', trigger: 'blur' },
        ]
        this.editFormRules.freeMinutesDaily = []
      }
    }
  }
}
</script>
<style scoped>
.button-group {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  max-width: 350px;
}
.button-group .el-button {
  margin-left: 0;
  margin-right: 5px;
  padding: 7px 10px;
}
.button-group .el-button:last-child {
  margin-right: 0;
}
/* 编辑和删除按钮保持小尺寸 */
.button-group .el-button.is-circle {
  padding: 7px;
}
.cardcss{
  margin: 5px auto ;
  width: 100%;
}
.el-breadcrumb{
  width: 100%;
}
el-table__row>td {
  border: none;
}

.el-table::before {
  height: 0px;

}
</style>